import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';
import { DayOfWeekOption } from '../models/day-of-week-option';

export const dayOfWeekOptionActions = createEagerSelectActions<DayOfWeekOption>('[Day Of Week Options]');
